
import { gtag, isGtagAvailable } from './gtag';
import { LeadFormData } from '@/types/lead';
import { GOOGLE_ADS_CONFIG } from './config';
import { resolveTrafficSource } from '@/utils/trafficSource';

export interface ConversionData {
  send_to: string;
  value?: number;
  currency?: string;
  transaction_id?: string;
  custom_parameters?: Record<string, any>;
}

// Track form submission (when user completes the lead form)
export const trackFormSubmission = (
  leadData: LeadFormData,
  utmParams?: Record<string, string>
) => {
  if (!isGtagAvailable()) {
    console.warn('gtag not available for form submission tracking');
    return;
  }

  console.log('Tracking form submission:', leadData.name);

  const conversionData: ConversionData = {
    send_to: `${GOOGLE_ADS_CONFIG.CONVERSION_ID}/${GOOGLE_ADS_CONFIG.CONVERSIONS.FORM_SUBMITTED}`,
    value: GOOGLE_ADS_CONFIG.VALUES.FORM_SUBMITTED,
    currency: 'BRL',
    transaction_id: `form_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    custom_parameters: {
      lead_name: leadData.name,
      lead_whatsapp: leadData.whatsapp,
      lead_cnpj: leadData.cnpj,
      ...utmParams
    }
  };

  // Track conversion
  gtag('event', 'conversion', conversionData);

  // Enhanced conversion with user data
  gtag('event', 'conversion', {
    ...conversionData,
    user_data: {
      phone_number: leadData.whatsapp
    }
  });

  // Track as GA4 custom event for analytics reporting
  const { sourceName } = resolveTrafficSource();
  gtag('event', 'generate_lead', {
    event_category: 'form',
    event_label: 'calculator_form',
    lead_source: 'website',
    traffic_source: sourceName,
    ...utmParams
  });

  console.log('Form submission tracked:', conversionData);
};

// Track WhatsApp button clicks (any CTA that leads to WhatsApp)
export const trackWhatsAppClick = (
  source: string, // e.g., 'cta_button', 'mobile_cta', 'form_redirect', 'hero_section'
  utmParams?: Record<string, string>
) => {
  if (!isGtagAvailable()) {
    console.warn('gtag not available for WhatsApp click tracking');
    return;
  }

  console.log('Tracking WhatsApp click from:', source);

  const conversionData: ConversionData = {
    send_to: `${GOOGLE_ADS_CONFIG.CONVERSION_ID}/${GOOGLE_ADS_CONFIG.CONVERSIONS.WHATSAPP_CLICK}`,
    value: GOOGLE_ADS_CONFIG.VALUES.WHATSAPP_CLICK,
    currency: 'BRL',
    transaction_id: `whatsapp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
    custom_parameters: {
      click_source: source,
      ...utmParams
    }
  };

  gtag('event', 'conversion', conversionData);
  
  // Also track as a custom event for analytics
  gtag('event', 'whatsapp_click', {
    event_category: 'engagement',
    event_label: source,
    button_location: source,
    ...utmParams
  });

  console.log('WhatsApp click tracked:', conversionData);
};
